<script setup>
import { ref, watch } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";

const props = defineProps({
  selectId: {
    type: String,
    default: "exampleSelect",
  },
  modelValue: {
    type: [Date, Array, Number],
    default: null,
  },
  range: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  modelType: {
    type: String,
    default: "timestamp",
  },
  enableTimePicker: {
    type: Boolean,
    default: false,
  },
  hideInput: {
    type: Boolean,
    default: false,
  },
  customInput: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "open", "closed", "cleared"]);

const datePicker = ref();

const selectedDate = ref(props.modelValue); // Temporary date selection

const selectDate = () => {
  datePicker.value.selectDate();

  applyDate();
};

watch(
  () => props.modelValue,
  (newValue) => {
    selectedDate.value = newValue;
  }
);

// Function to apply the selected date to modelValue
const applyDate = () => {
  emit("update:modelValue", selectedDate.value);
};

defineExpose({
  datePicker,
});
</script>

<template>
  <vue-date-picker
    ref="datePicker"
    v-model="selectedDate"
    :range="range"
    :model-type="modelType"
    :disabled="disabled"
    :enable-time-picker="enableTimePicker"
    :clearable="false"
    @open="$emit('open')"
    @closed="$emit('closed')"
    @cleared="$emit('cleared')"
    :class="['custom-datepicker', { hideInput: hideInput }]"
  >
    <!-- Hide the input bar by using an empty input slot -->
    <template v-if="customInput" #dp-input>
      <slot name="custom-input"></slot>
    </template>

    <template #action-buttons>
      <CustomButton button-type="blue" has-font-semi-bold @click="selectDate">
        <span>Apply</span>
      </CustomButton>
    </template>
  </vue-date-picker>
</template>

<style scoped lang="scss">
.custom-datepicker {
  margin: 0.625rem 0;
  height: 2.375rem;

  &.hideInput {
    :deep {
      .dp__input_wrap {
        display: none;
      }
    }
  }
}

.dp__theme_light {
  --dp-background-color: #{$bluish-gray-50};
  --dp-border-color-hover: #{$bluish-gray-200};
  --dp-border-color-focus: #{$bluish-gray-200};
}

:deep {
  .dp__arrow_bottom,
  .dp__arrow_top {
    display: none;
  }

  // .dp__range_between,
  // .dp__range_end,
  // .dp__range_start {
  //   border-radius: 200px;
  //   color: var(--primary-250) !important;
  //   border: 1px solid var(--primary-100) !important;
  //   background: transparent !important;
  // }

  .dp__cell_inner {
    color: $neutral-400;
    font-size: 14px;
    font-weight: 600;
    // border-radius: 200px;
  }

  .dp__calendar_header_separator {
    display: none;
  }

  .dp__calendar_header_item {
    color: $neutral-250;
    font-size: 14px;
  }

  .dp__instance_calendar {
    // width: 320px;
    border-radius: 8px;
  }

  .dp__menu {
    border-radius: 8px;
  }
}
</style>
